export enum GiftingFlowType {
  OneToOne = 'one-to-one',
  Prospecting = 'prospecting',
}
